import { Img } from 'components/common/imageComponents/Image/styles';
import { ImgWrapperProps } from 'components/common/imageComponents/Image/types';
import { defaultAlt } from 'constants/defaults';
import React from 'react';

interface Props extends ImgWrapperProps {}

export const Image = ({ src, alt = defaultAlt, ...rest }: Props) => <Img alt={alt} src={src} {...rest} />;
